/**************************************************
 * Nombre:       Formulario_Pedido_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import {generarGuia} from "../../Modulo_envios/Funciones/generarGuia";
import {BODEGA} from "../../Modulo_envios/Constantes_Bodega";
import {obtenerValorTotal} from "../../Modulo_envios/Funciones/obtenerValorTotal";
import Formulario_Pedido_Pago from "../Formularios/Formulario_Pedido_Pago";

const Dialogo_Pedido_Pago = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })

    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga()

        let dox = await guardarDoc('pedidos', entidad)
        if (dox.res) {
            await guardarFecha()
            terminar({aviso: 'Datos de pedido actualizados'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }


    const crearGuia = async () => {
        let valorProductos = obtenerValorTotal(datos.productos)
        let guia = await generarGuia({bodega: BODEGA, pedido: datos, valorTotal: valorProductos})
        console.log(guia)
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Pedido_Pago props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Pedido_Pago